module.exports = __webpack_public_path__ + "static/media/tm-colorit-12-sm.752c439c.webp";